'use strict';
import $ from 'jquery';
$.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, { passive: true });
    }
};
$.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};
$.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
import bootstrap from 'bootstrap';
import tooltip from './Tooltip';
import AnimatePlus from '../../node_modules/animateplus/animateplus.js';
import Slick from './slick.js';
// import DataTables from '../../node_modules/datatables/media/js/jquery.dataTables';
// import DataTablesCheckbox from '../../node_modules/jquery-datatables-checkboxes/js/dataTables.checkboxes';
import Animation from '../../node_modules/animate-js/dist/animate-js';
import Lazyload from './lazysizes.min';
import Header from './header-th';
import StickyNav from './sticky-nav';
import PressRelease from './newsroom';
import ScrollTop from './scroll-top';
import Awards from './awards-section';
import BannerTime from './banner-time';
import Bounce from './bounce-arrow';
import Homebannertwo from './home-banner-two';
import Homebannerthree from './home-banner-three';
import contactus from './contactus-th';
// import HighchatCustom from './highchat-custom';
import Colorbox from './colorbox';
import Insights from './insights-th';
import ModalPopup from './modal-popup';
import LineAnimation from './line-animation';
import NumCount from './number-count';
import Stories from './stories';
import YearSlick from './year-slick';
import Covid from './covid-slider';
import DataTable from './datatables.min';
import DataCheckbox from './dataTables.checkboxes.min';
// import FundsGrid from './funds-grid';
import Filter from './filter';
import FundsTH from './funds-th';
import Heritage from './heritage';
import MobileSlick from './mobile-slick';
import Datepiker from './bootstrap-datepicker.min';
import FundDetails from './funddetails-th';
import Chosen from './chosen.jquery.min';
import login from './login-btn';
import commonth from './common-th';
import subscribeform from './Subcribeform-th';
import SwiperCarosel from './swiper-carosel';
import article from './article';
import DataTableFixedHeader from './dataTablesfixedHeader.min';





// import Article from './article';
// import Dividendsec from './dividendsec-grid';
// import downloadsec from './downloadsec-grid';
// import navsecgrid from './navsec-grid';


// import FundSlick from './fund-slick';